var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-subnav--slider"},_vm._l((_vm.items),function(item){return _c('NavSliderItem',_vm._b({key:item.id,attrs:{"isActive":_vm.activeItemId === item.id}},'NavSliderItem',item,false))}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c8ac10a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/mobile/components/NavSlider/NavSlider.vue
// module id = 1245
// module chunks = 0